// extracted by mini-css-extract-plugin
export default {"dragDropText":"FileDrop_dragDropText__cG1vT","dragDropRequirement":"FileDrop_dragDropRequirement__gI5pX"};